import { GET_DASHBOARD } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_DASHBOARD:
            return action.payload;
        default:
            return state;
    }
}
